import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
      <div className="font-display text-white/40 text-xs tracking-[0.3em]">LOADING…</div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  // Phase 1: any staff role (admin / executive / viewer) may access /admin/*.
  // Granular role enforcement (mutations, deletes, user mgmt) happens at the
  // backend AND inside each admin screen.
  if (requireAdmin && !user.is_staff) return <Navigate to="/" replace />;
  return children;
}
